import * as React from 'react';
import { FC, Fragment, useEffect } from 'react';
import {
    BooleanField,
    Datagrid,
    DateField,
    DateInput,
    downloadCSV,
    EmailField,
    Filter,
    List,
    SearchInput,
    SelectInput,
    TextField,
    NumberInput,
    usePermissions,
    useTranslate,
    TextInput,
    ReferenceInput,
    ReferenceField
} from 'react-admin';

import ListActions from '../components/actions';
import BulkDeleteButton from '../components/actionsBulkDelete';
import { unparse as convertToCSV } from 'papaparse/papaparse.min';
import ListEmpty from '../components/listEmpty';
import { FilterProps, PermissionsType } from "../../types";
import ListPagination from "../components/ListPagination";
import CustomizableDatagrid from '../components/CustomizableDatagrid';
import Fields from './dataset';
import { NumberField } from 'react-admin';
import { ImageField } from 'react-admin';
import { SelectField } from 'react-admin';
import { ChipField } from 'react-admin';
import ChipFieldJsonb from '../components/ChipFieldJsonb';
import CreateField from '../components/editField';
import exporter from './exporter';
import ReferenceFieldFullName from './ReferenceFieldFullName';
import ButtonExperiencer from './LinkToExperiencer';
import { useHistory } from 'react-router';
import { useApolloClient } from '@apollo/client';
import { AutocompleteInput } from 'react-admin';
import ReferenceFieldBirthday from './ReferenceFieldBirthday';
import ReferenceFieldGender from './ReferenceFieldGender';
import ReferenceFieldAge from './ReferenceFieldAge';

const ExportableFields = Fields.filter(d => d.export);
const UserBulkActionButtons = (props: JSX.IntrinsicAttributes) => {
    const { permissions } = usePermissions();
    const role = permissions?.role;
    const permission = permissions?.list_permission as PermissionsType;
    return (
        <Fragment>
            {(role ==='admin') && (permission?.permission_approve === true || permission?.permission_all === true) && <BulkDeleteButton {...props} />}
        </Fragment>
    )
};
const TeamFilter: FC<Omit<FilterProps, 'children'>> = props => {
    const translate = useTranslate();
    return (
        <Filter {...props}>
            <NumberInput source="id@_eq" label={translate('user_list.id')} alwaysOn />
            <ReferenceInput allowEmpty={true} filterToQuery={(searchText: any) => ({ name: searchText })} source="team_id" reference="team" label={translate('team_contact.team_id')} alwaysOn>
                <AutocompleteInput optionText={'name'}/>
            </ReferenceInput>
            <SearchInput source="note,phone,message" alwaysOn />
        </Filter>
    )
};
const AccountReferenceField = (props: any) => {
    return <ReferenceField {...props} source={'account_id'} reference={'account'} link={false}>
            <TextField source={'name'} />
    </ReferenceField>
}
const UserList = (props: any) => {
    const translate = useTranslate();
    const { permissions } = usePermissions();
    const apolloClient = useApolloClient();
    const dataFilter = props.location.search as string;
    const checkStatus = dataFilter.includes('@_neq%22:1');
    const role = permissions?.role;
    const permission = permissions?.list_permission as PermissionsType;
    let edit = (permission?.permission_create_edit == true || permission?.permission_all == true) ? 'edit': '';
    const module = 'team_contact';
    const history = useHistory();
    useEffect( () => {
        history.location.pathname = '/team_contact';
    },[props]);
    if (role ===undefined) {
        return null;
    }
    console.log({ permissions });

    return (
        <List
            {...props}
            filters={<TeamFilter />}
            sort={{ field: 'id', order: 'DESC' }}
            perPage={25}
            bulkActionButtons={<UserBulkActionButtons />}
            pagination={<ListPagination />}
            exporter={(items: any,fetchRelatedRecords:any) => exporter(items, 'team_contact', ExportableFields, translate,fetchRelatedRecords,apolloClient )}
            actions={<ListActions to='team_contact' />}
            empty={<ListEmpty />}
            title={<CreateField titlePage={''} />}
        >
            <CustomizableDatagrid rowClick={edit}>

                {Fields.map((f, idx) => {
                    if (!Boolean(f)) return <></>
                    const { name, reference, searchField, type, options } = f || {}
                    if (type === 'textinput') {
                        // if (numberFormat) {
                        //     return <NumberField source={name} label={translate(`${module}.${name}`)} />
                        // }
                        return <TextField source={name} label={translate(`${module}.${name}`)} />
                    }

                    if (type === 'reference') {
                        if (name === 'user_id') {
                            return  <ReferenceFieldFullName source="user_id" label={translate(`${module}.${name}`)} reference='user'/>
                        }
                        return <ReferenceField label={translate(`${module}.${name}`)} source={name} reference={reference} link={false}>
                            <TextField source={searchField} />
                        </ReferenceField>
                    }
                    if (type === 'account_name') {
                        return <ReferenceField link={false} label={translate(`${module}.account_name`)} source={'team_id'} reference={'team'}>
                            <AccountReferenceField />
                        </ReferenceField>
                    }
                    if (type === 'date' || type === 'datetime') {
                        return <DateField showTime={true} source={name} label={translate(`${module}.${name}`)} locales="ja-JP" />
                    }
                    if (type === 'imagefield') {
                        return <ImageField source={name} label={translate(`${module}.${name}`)} locales="ja-JP" />
                    }

                    if (type === 'checkbox') {
                        return <BooleanField source={name} label={translate(`${module}.${name}`)} />
                    }
                    if (type === 'gender') {
                        return <ReferenceFieldGender source="user_id" label={translate(`${module}.${name}`)} reference='user' />
                    }
                    if (type === 'birthday') {
                        return <ReferenceFieldBirthday source="user_id" label={translate(`${module}.${name}`)} reference='user' />
                    }
                    if (type === 'age') {
                        return <ReferenceFieldAge source="user_id" label={translate(`${module}.${name}`)} reference='user' />
                    }
                    if (type === 'selectbox') {
                        return <SelectField
                            source={name}
                            choices={options}
                            label={translate(`${module}.${name}`)}
                        />
                    }
                    if (type === 'status') {
                        if(name === 'contact_status' && checkStatus === true){
                            return <></>
                        }else {
                            return <SelectField
                            source={name}
                            choices={options}
                            label={translate(`${module}.${name}`)}
                        />
                        }
                       
                    }
                    if (type === 'jsonb') {
                        return <ChipFieldJsonb
                            source={name}
                            label={translate(`${module}.${name}`)}
                        />
                    }
                    if (type === 'button_filter') {
                        if (name === 'button_filter_team_contact') {
                            return <ButtonExperiencer source={" "} />
                        }
                    }
                    return <></>
                })}
            </CustomizableDatagrid>
        </List>

    );
};

export default UserList;
